module.exports = __webpack_public_path__ + "img/1513850301.bde80ebf.jpg";